export default __webpack_public_path__ + "static/media/gâteau.ab29332a.jpg";